var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.99,
    height: 36.058,
    viewBox: "0 0 35.99 36.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.288,
    y1: -0.462,
    x2: 1.661,
    y2: 1.251,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfa67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#c82c6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6325c4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Unione_4",
    "data-name": "Unione 4",
    d: "M9.21,33a1.211,1.211,0,0,1,1.14-2.136A15.193,15.193,0,0,0,20.9,32.247a1.21,1.21,0,0,1,.55,2.352A17.589,17.589,0,0,1,9.21,33Zm15.4-1.463A1.212,1.212,0,0,1,25.2,30.5,15.112,15.112,0,0,0,17.455,2.419a1.21,1.21,0,1,1,0-2.419,17.53,17.53,0,0,1,8.992,32.578,1.209,1.209,0,0,1-1.832-1.038Zm-18.38-.954a1.2,1.2,0,0,1-.831-.332,17.485,17.485,0,0,1-4.984-8.58,1.21,1.21,0,1,1,2.352-.57,15.071,15.071,0,0,0,4.3,7.4,1.21,1.21,0,0,1-.832,2.09Zm10.042-4.86V18.8H9.351V16.376h6.926V9.452h2.432v6.925h6.925L25.627,18.8H18.7v6.925ZM1.1,17.114A1.212,1.212,0,0,1,.005,15.8v-.011a17.35,17.35,0,0,1,1.551-5.647A1.21,1.21,0,0,1,3.75,11.162a14.979,14.979,0,0,0-1.33,4.862,1.21,1.21,0,0,1-1.2,1.091ZM6.292,6.868a1.209,1.209,0,0,1-.934-1.976q.162-.2.329-.39a1.212,1.212,0,0,1,1.83,1.589c-.1.11-.191.222-.284.336a1.209,1.209,0,0,1-.934.441Z",
    transform: "translate(0.506 0.5)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.d3eab3f516923530044420201b8ec402.svg";
export { ForwardRef as ReactComponent };